import { render, staticRenderFns } from "./CompulsaDocumento.vue?vue&type=template&id=14459979"
import script from "./CompulsaDocumento.vue?vue&type=script&lang=js"
export * from "./CompulsaDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports